import React from 'react';
import { ImageProps } from '.';

const SvgStoreZigzinEmblemBadge = ({ size = 76, ...props }: ImageProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={(size && Math.floor(size / 3.4545454545454546)) || 22}
      fill='none'
      viewBox='0 0 76 22'
      {...props}
    >
      <path
        fill='#fff'
        d='M0 4c0-2.21 2.075-4 4.635-4h66.73C73.925 0 76 1.79 76 4v14c0 2.21-2.075 4-4.635 4H4.635C2.075 22 0 20.21 0 18V4Z'
      />
      <path
        fill='#E2E5E6'
        d='M71.365 21v1H4.635v-1h66.73Zm3.476-3V4c0-1.605-1.46-2.916-3.297-2.996L71.365 1H4.635c-1.92 0-3.476 1.343-3.476 3v14c0 1.657 1.556 3 3.476 3v1l-.239-.005c-2.37-.104-4.27-1.744-4.39-3.789L0 18V4c0-2.21 2.075-4 4.635-4h66.73C73.925 0 76 1.79 76 4v14l-.006.206c-.12 2.045-2.02 3.685-4.39 3.79l-.239.004v-1c1.92 0 3.476-1.343 3.476-3Z'
      />
      <path
        fill='#216BFF'
        fillRule='evenodd'
        d='M49.474 16.153h-1.428v-5.452h-1.78c-.153 1.983-1.213 3.196-2.652 3.196-1.565 0-2.687-1.417-2.676-3.684-.01-2.244 1.111-3.672 2.675-3.672 1.395 0 2.432 1.15 2.642 3.004h1.79v-3.73h1.429v10.338Zm-5.86-8.309c-.771 0-1.304.84-1.293 2.37-.011 1.541.522 2.368 1.293 2.368.781 0 1.292-.827 1.292-2.369 0-1.53-.51-2.368-1.292-2.369Z'
        clipRule='evenodd'
      />
      <path
        fill='#216BFF'
        d='M59.205 16.13h-1.451v-2.493h-5.645V12.48h7.096v3.65ZM63.552 14.793h5.724v1.156H62.09v-3.344h1.462v2.188ZM13.508 6.19c2.993-.048 5.42 1.842 5.42 4.643l-.007.259c-.145 2.657-2.514 4.429-5.413 4.382-.554-.009-.98-.076-1.583-.244-1.887-.526-5.6-2.77-6.862-3.705-.128-.095-.045-.286.117-.27l7.599.728c.116.012.183.129.127.225l-.732 1.253c-.08.139.089.286.231.202l4.42-2.639a.22.22 0 0 0 0-.384l-4.42-2.638c-.142-.085-.311.063-.23.201l.731 1.254c.055.096-.011.212-.127.224l-7.599.729c-.162.015-.244-.175-.117-.27 1.262-.934 4.975-3.181 6.862-3.707.602-.167 1.029-.235 1.583-.243ZM39.3 7.686h-5.747v1.031h5.51v1.134h-5.51v1.077h5.827v1.144h-2.97v1.746h4.001v1.156h-9.442v-1.156h3.978v-1.745H32.08V6.53h7.22v1.156ZM30.611 14.86H21.17v-1.19h9.442v1.19ZM69.004 13.285h-1.45V5.827h1.45v7.458ZM66.465 7.708h-2.074v.148c0 1.235.76 2.494 2.46 3.004l-.737 1.133c-1.156-.363-1.973-1.105-2.437-2.04a4.159 4.159 0 0 1-2.517 2.233l-.748-1.134c1.712-.555 2.505-1.893 2.505-3.196v-.148h-2.12V6.552h5.668v1.156ZM59.205 12.027h-1.451V5.815h1.45v6.212ZM26.599 7.176c0 1.507 1.337 3.128 3.672 3.525l-.634 1.201c-1.797-.357-3.135-1.365-3.798-2.697-.685 1.32-2.023 2.335-3.808 2.697l-.624-1.201c2.29-.408 3.639-2.03 3.65-3.525v-.748H26.6v.748ZM56.666 7.572H54.59c.011 1.208.771 2.477 2.46 2.981l-.737 1.123c-1.156-.357-1.972-1.1-2.437-2.04-.47 1.02-1.31 1.83-2.516 2.232l-.748-1.122c1.7-.55 2.493-1.887 2.505-3.174h-2.12V6.416h5.668v1.156Z'
      />
    </svg>
  );
};

export default SvgStoreZigzinEmblemBadge;
